import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
  FaChild,
  FaHeartbeat,
  FaUserNurse,
  FaBrain,
  FaLungs,
  FaTeeth,
} from "react-icons/fa";

const Departments = () => {
  const { t } = useTranslation();

  const icons = [
    <FaChild className="text-white text-4xl" />,
    <FaHeartbeat className="text-white text-4xl" />,
    <FaUserNurse className="text-white text-4xl" />,
    <FaBrain className="text-white text-4xl" />,
    <FaLungs className="text-white text-4xl" />,
    <FaTeeth className="text-white text-4xl" />,
  ];

  const bgColors = [
    "bg-pink-700",
    "bg-red-500",
    "bg-purple-500",
    "bg-blue-500",
    "bg-green-500",
    "bg-yellow-500",
  ];

  const departments = t("departments.list", { returnObjects: true });

  return (
    <section
      id="Departments"
      className="py-20 bg-gradient-to-br from-purple-100 via-pink-50 to-blue-100 px-4"
    >
      <div className="max-w-6xl mx-auto text-center">
        <motion.h2
          className="text-4xl font-extrabold text-purple-700 mb-4"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {t("departments.heading")}
        </motion.h2>

        <motion.p
          className="text-gray-700 max-w-2xl mx-auto mb-10 text-lg"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          {t("departments.description")}
        </motion.p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {departments.map((deptTitle, index) => (
            <motion.div
              key={index}
              className={`${bgColors[index % bgColors.length]} rounded-xl shadow-lg p-6 hover:shadow-2xl transition transform hover:-translate-y-2 flex flex-col items-center text-white`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="mb-4">{icons[index % icons.length]}</div>
              <h4 className="text-lg font-semibold text-center">{deptTitle}</h4>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Departments;
